export default __webpack_public_path__ + "static/media/booked_shift.ff9272b0.svg";